// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html {
  position: relative;
  min-height: 100%;
}

body {
  font-family: "century gothic", verdana;

}

.btn-link {
  cursor: pointer;
}

.btn {
  margin: 10px 3px 10px 3px;
}

.table td{
  vertical-align: middle;
}

.title {
  text-align: center;
}

.tableHeadBlack {
  color: black !important;
}

.bottom-0 { 
  bottom: 0;
}

.btnBlue {
  background-color: rgb(0, 155, 229) !important;
}

.main {
  width: 400px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.paper{
  display: flex;
    padding: 16px 24px 24px;
    margin-top: 64px;
    align-items: center;
    flex-direction: column;
}
.avatar{
    margin: 8px;
    background-color: rgb(225, 0, 80) !important;
}

.icon{
  cursor: pointer;
}

.saveButton {
  margin-left: 0;
}

span[class^='MuiTab-wrapper'] {
  display: block !important;
}

.modal {
  overflow-y: auto !important;
}

@media screen and (max-width: 450px) {
  .main {
    width: 100%
  }

  .headerTab {
    font-size: 0.675rem !important;
  }
  .h2 {
    font-size: 1.2rem !important;
  }
  .h3 {
    font-size: 1rem !important;
  }
  .h4 {
    font-size: 1rem !important;
  }
  .title {
    font-size: 1rem !important;
  }
  .impressumInfo {
    font-size: 0.8rem !important;
  }
  .ta-sm-right {
    text-align: right !important;
  }
}

@media screen and (min-width: 450px) {
  .container {
    max-width: 80%;
  }
}

.overflowTable {
  overflow-x: auto;
  overflow-y: hidden;
}

.tableFooter {
  color: black;
  font-size: 0.8rem;
}

.buttonProgress {
  color:#368ee0 !important;
  position:fixed;
  top:50%;
  left:50%;
  z-index: 1300;
}

.header-link {
  color: #444;
  padding: 8px 17px;
  cursor: pointer;
  font-size: 0.8125rem;
}

.header-link:hover {
  text-decoration: underline;
  color: #444;
}

.header-separator {
  color: #a3a3a3;
  padding: 4px 0px;
}

.activeTab {
  background-color: #348cb6 !important;
}

.footer {
  position: absolute;
  bottom: 0;
  height: 60px; /* Set the fixed height of the footer here */
  line-height: 60px; /* Vertically center the text there */
  right: 0;
  width: 50%;
  top: 100% !important;
}

.headerInfo {
  font-size: 0.9rem;
  display:inline-block;
  margin-left: 20rem;
  position: absolute;
}

@media screen and (max-width:1600px) {
  .headerInfo {
    margin-left: 8rem;
  }
}

@media screen and (max-width:1400px) {
  .headerInfo {
    font-size: 0.7rem;
    margin-left: 7rem;
  }
}

@media screen and (min-width:576px) {
  .modal-dialog {
    max-width: 40%;
  }
}

@media screen and (max-height: 800px) {
  .footer {
    top: 100% !important;
  }
  .modal {
    top: 5% !important;
  }
}

.radioBlue {
  color:rgb(0, 155, 229) !important;
}

/* Fixes for IE */
input::-ms-clear {
  display: none;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .MuiTab-root {
    padding: 12px 12px !important;
  }
}

.warning .MuiInputBase-input, 
.warning .MuiFormLabel-root.Mui-disabled {
  color: red;
}

.underline {
  text-decoration: underline;
}

.MuiToolbar-root {
    display: flex;
    overflow: hidden;
    min-height: 48px !important;
    -webkit-overflow-scrolling: touch;
}

a {
  color: #007bff;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}

.MuiButton-text{
    color: white !important;
    opacity: 0.7;
}

.spacer {
  flex: 1;
}

.ml-2 {
  margin-left: 0.5rem !important;
} 

.mr-2 {
  margin-right: 0.5rem !important;
}

.width-auto {
  width: fit-content !important;
}

.float-right{
  float: right;
}`, "",{"version":3,"sources":["webpack://./styles/global.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;;AAExC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;IACX,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,4CAA4C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE;EACF;;EAEA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY,EAAE,4CAA4C;EAC1D,iBAAiB,EAAE,qCAAqC;EACxD,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;EACE,cAAc;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd","sourcesContent":["\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\nbody {\n  font-family: \"century gothic\", verdana;\n\n}\n\n.btn-link {\n  cursor: pointer;\n}\n\n.btn {\n  margin: 10px 3px 10px 3px;\n}\n\n.table td{\n  vertical-align: middle;\n}\n\n.title {\n  text-align: center;\n}\n\n.tableHeadBlack {\n  color: black !important;\n}\n\n.bottom-0 { \n  bottom: 0;\n}\n\n.btnBlue {\n  background-color: rgb(0, 155, 229) !important;\n}\n\n.main {\n  width: 400px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.paper{\n  display: flex;\n    padding: 16px 24px 24px;\n    margin-top: 64px;\n    align-items: center;\n    flex-direction: column;\n}\n.avatar{\n    margin: 8px;\n    background-color: rgb(225, 0, 80) !important;\n}\n\n.icon{\n  cursor: pointer;\n}\n\n.saveButton {\n  margin-left: 0;\n}\n\nspan[class^='MuiTab-wrapper'] {\n  display: block !important;\n}\n\n.modal {\n  overflow-y: auto !important;\n}\n\n@media screen and (max-width: 450px) {\n  .main {\n    width: 100%\n  }\n\n  .headerTab {\n    font-size: 0.675rem !important;\n  }\n  .h2 {\n    font-size: 1.2rem !important;\n  }\n  .h3 {\n    font-size: 1rem !important;\n  }\n  .h4 {\n    font-size: 1rem !important;\n  }\n  .title {\n    font-size: 1rem !important;\n  }\n  .impressumInfo {\n    font-size: 0.8rem !important;\n  }\n  .ta-sm-right {\n    text-align: right !important;\n  }\n}\n\n@media screen and (min-width: 450px) {\n  .container {\n    max-width: 80%;\n  }\n}\n\n.overflowTable {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.tableFooter {\n  color: black;\n  font-size: 0.8rem;\n}\n\n.buttonProgress {\n  color:#368ee0 !important;\n  position:fixed;\n  top:50%;\n  left:50%;\n  z-index: 1300;\n}\n\n.header-link {\n  color: #444;\n  padding: 8px 17px;\n  cursor: pointer;\n  font-size: 0.8125rem;\n}\n\n.header-link:hover {\n  text-decoration: underline;\n  color: #444;\n}\n\n.header-separator {\n  color: #a3a3a3;\n  padding: 4px 0px;\n}\n\n.activeTab {\n  background-color: #348cb6 !important;\n}\n\n.footer {\n  position: absolute;\n  bottom: 0;\n  height: 60px; /* Set the fixed height of the footer here */\n  line-height: 60px; /* Vertically center the text there */\n  right: 0;\n  width: 50%;\n  top: 100% !important;\n}\n\n.headerInfo {\n  font-size: 0.9rem;\n  display:inline-block;\n  margin-left: 20rem;\n  position: absolute;\n}\n\n@media screen and (max-width:1600px) {\n  .headerInfo {\n    margin-left: 8rem;\n  }\n}\n\n@media screen and (max-width:1400px) {\n  .headerInfo {\n    font-size: 0.7rem;\n    margin-left: 7rem;\n  }\n}\n\n@media screen and (min-width:576px) {\n  .modal-dialog {\n    max-width: 40%;\n  }\n}\n\n@media screen and (max-height: 800px) {\n  .footer {\n    top: 100% !important;\n  }\n  .modal {\n    top: 5% !important;\n  }\n}\n\n.radioBlue {\n  color:rgb(0, 155, 229) !important;\n}\n\n/* Fixes for IE */\ninput::-ms-clear {\n  display: none;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .MuiTab-root {\n    padding: 12px 12px !important;\n  }\n}\n\n.warning .MuiInputBase-input, \n.warning .MuiFormLabel-root.Mui-disabled {\n  color: red;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.MuiToolbar-root {\n    display: flex;\n    overflow: hidden;\n    min-height: 48px !important;\n    -webkit-overflow-scrolling: touch;\n}\n\na {\n  color: #007bff;\n    text-decoration: none;\n    background-color: transparent;\n    -webkit-text-decoration-skip: objects;\n}\n\n.MuiButton-text{\n    color: white !important;\n    opacity: 0.7;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.ml-2 {\n  margin-left: 0.5rem !important;\n} \n\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n\n.width-auto {\n  width: fit-content !important;\n}\n\n.float-right{\n  float: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
